import { BdkAiBadge } from '@breuni-ui/bdk-ai-badge';
import { safeDefine } from '@breuni-ui/safe-define';
import { html, TemplateResult } from 'lit';
import { getBadgeLocale } from '../../../scripts/service/badge-locale.js';

safeDefine('ents-ai-badge', BdkAiBadge);

/**
 * Renders the shared AI-content marking badge. `className` lets each surface apply its own
 * positioning. The click handler both prevents default (the badge can sit inside a link, e.g.
 * cart-favorites) and stops propagation (it can sit inside a clickable tile), so activating the
 * badge never navigates away or triggers the surrounding element.
 */
export const renderAiBadge = (className: string): TemplateResult => {
  const { lang, country } = getBadgeLocale();
  return html`<ents-ai-badge
    class="${className}"
    data-test-ents-ai-badge
    lang="${lang}"
    country="${country}"
    variant="overlay-light"
    size="small"
    @click="${(e: Event) => {
      e.preventDefault();
      e.stopPropagation();
    }}"
  ></ents-ai-badge>`;
};
